import React from 'react';
import OperationsInfoTip from './OperationsInfoTip';
import { operationsTabInfo } from '../../../config/operationsMetricDefinitions';

type OperationsPanelShellProps = {
  title: string;
  description?: string;
  tabInfoKey?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

/** Shared scrollable panel — matches WhatsAppPanelShell */
const OperationsPanelShell: React.FC<OperationsPanelShellProps> = ({
  title,
  description,
  tabInfoKey,
  actions,
  children,
}) => (
  <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
    <div className="shrink-0 border-b border-gray-200 bg-white px-4 py-4 dark:border-gray-700 dark:bg-gray-900 sm:px-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
            {tabInfoKey && operationsTabInfo[tabInfoKey] && (
              <OperationsInfoTip metricKey={tabInfoKey} title={title} info={operationsTabInfo[tabInfoKey]} />
            )}
          </div>
          {description && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap gap-2">{actions}</div>}
      </div>
    </div>
    <div className="min-h-0 flex-1 overflow-y-auto p-4 sm:p-6">{children}</div>
  </div>
);

export default OperationsPanelShell;
